import MainBlob from "../../animate/MainBlob";
import style from "./ExampleSlider.module.scss";
import { ReactCompareSlider, ReactCompareSliderImage } from "react-compare-slider"

function ExampleSlider({ dictionary, sliderData, isSliderLeft = false, isBlurBack = false }) {

    return (
        <section className={`${style.container} ${isBlurBack ? style.blurBack : ""}`} style={{ flexDirection: `${isSliderLeft ? "row-reverse" : "row"}` }}>
            <div className={style.text}>
                <h2 className={style.title}>{dictionary[sliderData.title] || sliderData.title}</h2>
                <p className={style.description}>{dictionary[sliderData.description] || sliderData.description}</p>
            </div>

            <ReactCompareSlider
                className={style.item}
                // boundsPadding={20}
                changePositionOnHover
                handle={<div className={`${isSliderLeft ? style.altHandle : style.handle}`} ><button className={style.handleBtn}></button></div>}
                itemOne={<ReactCompareSliderImage alt="Image one" src={sliderData.beforeUrl} style={{ borderRadius: "24px", maxHeight: "422px" }} />}
                itemTwo={<ReactCompareSliderImage alt="Image two" src={sliderData.afterUrl} style={{ borderRadius: "24px", maxHeight: "422px" }} />}
                position={30}
            />
            {isBlurBack && <MainBlob isBack={true} isBlur={true} />}
        </section>
    );
}

export default ExampleSlider;